/**
 * Fetches a color value from the theme's colors, automatically assuming the path
 * starts with 'colors.' and ends with '.base.hex'. This simplifies the usage when
 * you're accessing color values that follow this consistent structure in the theme.
 *
 * @param {Object} theme
 * @param {String} colorKey - The middle part of the path in the theme, omitting 'colors.' and '.base.hex'.
 * @param {String} [fallback='inherit'] - Optional fallback color if the path doesn't resolve.
 * @returns {String} - The resolved color value or the fallback.
 */

const getColor = (theme, colorKey, shade = 'base', fallback = 'inherit') => {
  const fullPath = `colors.${colorKey}.${shade}.hex`
  return (
    fullPath.split('.').reduce((acc, part) => acc?.[part], theme) || fallback
  )
}

export default getColor
